'use es6';

import { fromJS, List } from 'immutable';
import { Config } from '../..';
import { SEARCH } from '../../../constants/configTypes';
import { SOCIAL_POSTS } from '../../../constants/dataTypes';
import { SUM } from '../../../constants/metricTypes';
import { EQ, IN } from '../../../constants/operators';
import { DESC } from '../../../constants/sortOrder';
import { CHANNEL_TYPES } from '../../../properties/data-type/social-posts';
import { Metric } from '../../metrics';
import { buildDrilldownReport } from '../report';

/*
First break down into channels via channelType agg and filter, which shows a count on published posts, interactions and clicks per channel
Then if those metrics are clicked, break into posts for that channel via post id agg and channelId filter
 */

const CHANNEL_COLUMN_METRIC_NAMES = ['interactionsTotal', 'stats.clicks'];
const POST_COLUMN_METRIC_NAMES = ['publishedAt', 'broadcastGuid', 'body', 'url', 'channelId', 'interactionsTotal', 'stats.clicks', 'stats.impressions', 'stats.shares'];
const CUSTOM_FILTERS_PATH = ['config', 'filters', 'custom'];
const METRICS_PATH = ['config', 'metrics'];
const hideColumn = (report, metricName) => {
  return report.setIn(['displayParams', 'columns', metricName, 'hideColumn'], true);
};
const generateSocialPostsDrilldown = (report, keys, options) => {
  const sortProperty = keys.get(-2);
  const filterValue = keys.get(-3);
  const currentFilters = report.getIn(CUSTOM_FILTERS_PATH) || List();
  let currentMetrics = report.getIn(METRICS_PATH);
  const dimension = CHANNEL_TYPES.includes(filterValue) ? 'channelId' : 'id';
  let drilldownConfig = report.get('config').set('dimensions', List.of(dimension)).set('sort', fromJS([{
    property: sortProperty,
    order: DESC
  }]));
  if (dimension === 'channelId') {
    currentMetrics = currentMetrics.concat(CHANNEL_COLUMN_METRIC_NAMES.map(property => Metric({
      property,
      metricTypes: [SUM]
    })));
    drilldownConfig = drilldownConfig.set('metrics', currentMetrics);
    drilldownConfig = drilldownConfig.setIn(['filters', 'custom'], currentFilters.filterNot(f => f.get('property') === 'channelType').push(fromJS({
      property: 'channelType',
      operator: EQ,
      value: filterValue
    })));
  } else {
    const filters = filterValue ? report.getIn(['config', 'filters']).set('custom', currentFilters.push(fromJS({
      property: 'channelId',
      operator: IN,
      values: [filterValue]
    }))) : report.getIn(['config', 'filters']);
    drilldownConfig = Config({
      configType: SEARCH,
      limit: 5,
      dataType: SOCIAL_POSTS,
      metrics: POST_COLUMN_METRIC_NAMES.map(property => Metric({
        property
      })),
      filters,
      sort: fromJS([{
        property: 'publishedAt',
        order: DESC
      }])
    });
  }
  report = buildDrilldownReport(report, drilldownConfig, options);
  // lb - this is not effective, so still using enhanceSearchColumns to hide these (though i cannot see every wanting to show these values, they are internal-use or redundant)
  report = hideColumn(report, 'broadcastGuid');
  report = hideColumn(report, 'channelId');
  report = hideColumn(report, 'id');
  return Promise.resolve(report);
};
export default {
  isSupported: report => {
    const metrics = report.getIn(METRICS_PATH);
    // if we are solely asking for a count and not an actual metric, flip into dimension: channelType so we can show the count of posts per channel desc
    // intended to offer a useful experience for the Published Post report drilldown
    return report.getIn(['config', 'dataType']) === SOCIAL_POSTS && metrics && metrics.first().get('property') === 'count';
  },
  generate: generateSocialPostsDrilldown
};